/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Regprices1Inputs */

const id_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Reg.`)
};

const ms_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga Reg.`)
};

const da_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reg. Priser`)
};

const de_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reg. Preise`)
};

const en_us2_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reg. Prices`)
};

const es_es2_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios Reg.`)
};

const es_mx2_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios Reg.`)
};

const fil_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Presyong Regular`)
};

const fr_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix réguliers`)
};

const it_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi regolari`)
};

const hu_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normál árak`)
};

const nl_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reguliere prijzen`)
};

const no_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanlige priser`)
};

const pl_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny regularne`)
};

const pt_br2_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular prices`)
};

const pt_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços normais`)
};

const ro_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prețuri normale`)
};

const fi_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaalihinnat`)
};

const sv_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ord. priser`)
};

const vi_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá thường`)
};

const tr_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal Fiyatlar`)
};

const cs_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Běžné ceny`)
};

const bg_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редовни цени`)
};

const ru_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычные цены`)
};

const uk_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Звич. ціни`)
};

const ar_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار العادية`)
};

const hi_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य मूल्य`)
};

const th_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาปกติ`)
};

const ja_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常価格`)
};

const zh_cn2_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular prices`)
};

const zh_hant1_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular prices`)
};

const ko_components_stats_regprices1 = /** @type {(inputs: Components_Stats_Regprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular prices`)
};

/**
* | output |
* | --- |
* | "Reg. Prices" |
*
* @param {Components_Stats_Regprices1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_regprices1 = /** @type {((inputs?: Components_Stats_Regprices1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Regprices1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_regprices1(inputs)
	if (locale === "ms") return ms_components_stats_regprices1(inputs)
	if (locale === "da") return da_components_stats_regprices1(inputs)
	if (locale === "de") return de_components_stats_regprices1(inputs)
	if (locale === "en-US") return en_us2_components_stats_regprices1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_regprices1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_regprices1(inputs)
	if (locale === "fil") return fil_components_stats_regprices1(inputs)
	if (locale === "fr") return fr_components_stats_regprices1(inputs)
	if (locale === "it") return it_components_stats_regprices1(inputs)
	if (locale === "hu") return hu_components_stats_regprices1(inputs)
	if (locale === "nl") return nl_components_stats_regprices1(inputs)
	if (locale === "no") return no_components_stats_regprices1(inputs)
	if (locale === "pl") return pl_components_stats_regprices1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_regprices1(inputs)
	if (locale === "pt") return pt_components_stats_regprices1(inputs)
	if (locale === "ro") return ro_components_stats_regprices1(inputs)
	if (locale === "fi") return fi_components_stats_regprices1(inputs)
	if (locale === "sv") return sv_components_stats_regprices1(inputs)
	if (locale === "vi") return vi_components_stats_regprices1(inputs)
	if (locale === "tr") return tr_components_stats_regprices1(inputs)
	if (locale === "cs") return cs_components_stats_regprices1(inputs)
	if (locale === "bg") return bg_components_stats_regprices1(inputs)
	if (locale === "ru") return ru_components_stats_regprices1(inputs)
	if (locale === "uk") return uk_components_stats_regprices1(inputs)
	if (locale === "ar") return ar_components_stats_regprices1(inputs)
	if (locale === "hi") return hi_components_stats_regprices1(inputs)
	if (locale === "th") return th_components_stats_regprices1(inputs)
	if (locale === "ja") return ja_components_stats_regprices1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_regprices1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_regprices1(inputs)
	return ko_components_stats_regprices1(inputs)
});
export { components_stats_regprices1 as "components.stats.regPrices" }